/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Autore } from './autore';
import { Cancellazione } from './cancellazione';


export interface PraticaNotaDTO { 
    id?: string;
    created_at?: string;
    autore?: Autore;
    testo?: string;
    cancellazione?: Cancellazione;
}

